__turbopack_context__.v({
  "tooltip-cursor__tooltip": "tooltip-cursor-component-module-scss-module__axSqgW__tooltip-cursor__tooltip",
});
